var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
/*
 * Copyright (c) 2023 LS ELECTRIC Co. Ltd. All Reserved.
 */
/*******************************************************************
 * @author HyeongJin OH
 * @contact hjoh@detech.co.kr
 * @date 2023-09-19
 * @brief SEI 운영관리 - 일괄등록 개발
 *
 ********************************************************************/
import { useEffect, useState } from "react";
// recoil
import { useAsync } from "react-async";
import { useRecoilState, useRecoilValue, useSetRecoilState } from "recoil";
import { loadingBoxState } from "../../../../recoil/menuState";
import { userInfoLoginState } from "../../../../recoil/userState";
// utils
import dayjs from "dayjs";
import { alertState, curAdminTreeState } from "../../../../recoil/assessmentState";
import * as HTTPUTIL from "../../../../utils/api/HttpUtil";
import * as CUTIL from "../../../../utils/commUtils";
import * as CONST from "../../../../utils/Const";
import EhpPagination from "../../../common/pagination/EhpPagination";
import * as XLSX from "xlsx";
import { langId } from "../../../../recoil/langState";
import { useTrans } from "../../../../utils/langs/useTrans";
function EquipmentMultiRegist(props) {
    const t = useTrans();
    // recoil
    const userInfo = useRecoilValue(userInfoLoginState);
    const setLoadingBox = useSetRecoilState(loadingBoxState);
    const [recoilTree, setRecoilTree] = useRecoilState(curAdminTreeState);
    const [alert, setAlert] = useRecoilState(alertState);
    const langIds = useRecoilValue(langId);
    // props
    const { onClickTab, handleOpenPop, isMobile } = props;
    //
    // useState
    const [subZoneInfo, setSubZoneInfo] = useState([]);
    const [roomInfo, setRoomInfo] = useState([]);
    const [chnanTree, setChnanTree] = useState(null);
    //
    const [thaed, setThead] = useState([]);
    const [elecinfoItem, setElecinfoItem] = useState([]);
    const [fileName, setFileName] = useState("");
    const [uploadFileName, setUploadFileName] = useState("");
    const [excelArray, setExcelArray] = useState([]);
    const [status, setStatus] = useState([]);
    const [repop, setRepop] = useState(false);
    const [successList, setSuccessList] = useState([]);
    const [failList, setFailList] = useState([]);
    const [header, setHeader] = useState(null);
    const headerItem = [
        "no",
        "설비유형",
        "판넬명",
        "형명",
        "시리얼번호",
        "제조사",
        "제조년월",
        "메모",
        "ELECINFO01",
        "ELECINFO02",
        "ELECINFO03",
        "ELECINFO04",
        "ELECINFO05",
        "ELECINFO06",
        "ELECINFO07",
        "ELECINFO08",
        "ELECINFO09",
        "ELECINFO10",
        "ELECINFO11",
        "ELECINFO12",
        "ELECINFO13",
        "ELECINFO14",
        "ELECINFO15",
        "ELECINFO16",
        "ELECINFO17",
        "ELECINFO18",
        "ELECINFO19",
        "ELECINFO20",
        "ELECINFO21",
        "ELECINFO22",
        "ELECINFO23",
        "ELECINFO24",
        "ELECINFO25",
        "ELECINFO26",
        "ELECINFO27",
        "ELECINFO28",
        "ELECINFO29",
        "ELECINFO30",
    ];
    const Fielditem = ["no", "설비유형", "판넬명", "형명", "시리얼번호", "제조사", "제조년월", "메모"];
    // 페이지
    const defaultPageInfo = {
        size: 10,
        totalElements: 0,
        totalPages: 0,
        number: 0,
        psize: 10,
        listReload: false,
    };
    const [pageInfo, setPageInfo] = useState(defaultPageInfo);
    function handleCurPage(page) {
        setPageInfo(Object.assign(Object.assign({}, pageInfo), { number: page }));
    }
    let excelNoArray = excelArray.filter((list, idx) => list.no).map((list) => list);
    const ingNum = Math.round((status.length / excelNoArray.length) * 100);
    // 성공 및 실패 데이터
    let success = [];
    let fail = [];
    for (let i = 0; i < status.length; i++) {
        if (status[i].data.msg == "fail" || status[i].codeNum == 9999) {
            fail.push(status[i].body);
        }
        else if (status[i].data.msg == "success") {
            success.push(status[i].body);
        }
    }
    useEffect(() => {
        handleOpenPop("pop-finish-ok", _jsx(FinishPop, { successList: successList, failList: failList, thaed: thaed, onClickTab: onClickTab, repop: repop, htmlClose: _jsxs(_Fragment, { children: [_jsx("h1", { children: uploadFileName }), _jsx("button", Object.assign({ className: "btn btn-close js-close", onClick: (e) => Close("pop-finish-ok") }, { children: _jsx("span", Object.assign({ className: "hide" }, { children: "\uB2EB\uAE30" })) }))] }) }));
    }, [successList, failList, thaed, onClickTab, repop, uploadFileName]);
    function Close(id) {
        CUTIL.jsclose_Popup(id);
        setRepop(true);
    }
    let appPath = `companyId=${recoilTree.company.companyId}`;
    appPath = appPath + `&page=${pageInfo.number}&size=${pageInfo.size}`;
    // Tree API
    const { data: data, isLoading } = useAsync({
        promiseFn: HTTPUTIL.PromiseHttp,
        httpMethod: "GET",
        appPath: `/product/item/elecinfos?${appPath}`,
        appQuery: {},
        userToken: userInfo.loginInfo.token,
        watch: appPath + langIds,
    });
    useEffect(() => {
        if (data) {
            if (data.codeNum == CONST.API_200) {
                var jobList = [];
                for (let i = 0; i < 30; i++) {
                    const jobinfo = {
                        code: i < 9 ? `ELECINFO0${i + 1}` : `ELECINFO${i + 1}`,
                        thName: `Elec Info ${i + 1}`,
                        type: 0,
                        name: "-",
                        unit: "",
                        id: null,
                    };
                    jobList.push(jobinfo);
                }
                setThead(jobList);
                // 페이징 10씩 증가
                const startIdx = pageInfo.number * 10;
                const updatedBody = data.body.map((list, index) => {
                    const elecInfo = jobList.map((info) => {
                        const foundInfo = list.elecInfo.find((d) => d.code === info.code);
                        return foundInfo ? foundInfo : info;
                    });
                    return Object.assign(Object.assign({}, list), { elecInfo, rowNum: startIdx + index + 1 });
                });
                setElecinfoItem(updatedBody);
                setPageInfo(Object.assign(Object.assign({}, data.data.page), { psize: isMobile ? CONST.NUM_MLISTCNT : CONST.NUM_WLISTCNT, listReload: false })); //5, 10; //5, 10
            }
            else {
                // data.body.map((err) => (err.msg));
            }
        }
    }, [data, langIds]);
    // SubZone
    function SubZoneSelect(e) {
        return __awaiter(this, void 0, void 0, function* () {
            CUTIL.onClickSelect(e, CUTIL.selectOption);
            let data = [];
            data = yield HTTPUTIL.PromiseHttp({
                httpMethod: "GET",
                appPath: `/product/zone/${recoilTree.zone.zoneId}`,
                appQuery: {},
                userToken: userInfo.loginInfo.token,
            });
            setChnanTree(recoilTree);
            if (data) {
                if (data.codeNum == CONST.API_200) {
                    setSubZoneInfo(data.body);
                }
                else {
                    // need error handle
                    setAlert(Object.assign(Object.assign({}, alert), { type: CONST.TYPE_NONE, divTag: data.errorList.map((err) => err.msg) }));
                    CUTIL.jsopen_AlertPopup(CONST.POP_ALERT);
                }
            }
        });
    }
    function onClickSubZone(item) {
        setRecoilTree(Object.assign(Object.assign({}, recoilTree), { subZone: { subZoneId: item.subZoneId, subZoneName: item.subZoneName }, room: { roomId: "", roomName: "" } }));
    }
    // SubZone
    function RoomSelect(e) {
        return __awaiter(this, void 0, void 0, function* () {
            CUTIL.onClickSelect(e, CUTIL.selectOption);
            let data = [];
            data = yield HTTPUTIL.PromiseHttp({
                httpMethod: "GET",
                appPath: `/product/subzone/${recoilTree.subZone.subZoneId}`,
                appQuery: {},
                userToken: userInfo.loginInfo.token,
            });
            setChnanTree(recoilTree);
            if (data) {
                if (data.codeNum == CONST.API_200) {
                    setRoomInfo(data.body);
                }
                else {
                    // need error handle
                    setAlert(Object.assign(Object.assign({}, alert), { type: CONST.TYPE_NONE, divTag: data.errorList.map((err) => err.msg) }));
                    CUTIL.jsopen_AlertPopup(CONST.POP_ALERT);
                }
            }
        });
    }
    function onClickRoom(item) {
        if (item == "all") {
            setRecoilTree(Object.assign(Object.assign({}, recoilTree), { subZone: {
                    subZoneId: recoilTree.subZone.subZoneId,
                    subZoneName: recoilTree.subZone.subZoneName,
                }, room: { roomId: "", roomName: "" } }));
        }
        else {
            setRecoilTree(Object.assign(Object.assign({}, recoilTree), { room: { roomId: item.roomId, roomName: item.roomName } }));
        }
    }
    function ExcelInput(e) {
        let input = document.createElement("input");
        input.type = "file";
        input.accept = ".xls,.xlsx";
        input.onchange = (e) => {
            var _a;
            const selectedFile = (_a = e.target.files) === null || _a === void 0 ? void 0 : _a[0];
            ExleUPload(selectedFile);
        };
        input.click();
    }
    function ExleUPload(file) {
        var reader = new FileReader();
        //데이터 포맷
        const formData = new FormData();
        formData.append("files", file);
        //엑셀 upload
        reader.onload = function () {
            var fileData = reader.result;
            var xlsxUpload = XLSX.read(fileData, { type: "binary" });
            var xlsxSheet = xlsxUpload.Sheets[xlsxUpload.SheetNames[0]];
            var xlsxSheet1 = XLSX.utils.sheet_to_json(xlsxSheet);
            // 엑셀 헤드 추출
            var xlsxHeader = XLSX.utils.sheet_to_json(xlsxSheet, {
                header: 1,
                defval: "",
            });
            setExcelArray(xlsxSheet1);
            setHeader(xlsxHeader[0]);
        };
        reader.readAsBinaryString(file);
        setFileName(file.name);
        setUploadFileName("");
        setStatus([]);
    }
    let excelNoArr = excelArray
        .filter((list, idx) => list.no)
        .map((list, idx) => (Object.assign(Object.assign({}, list), { key: Object.keys(list).filter((key) => key.includes("ELECINFO")) })));
    // update API
    function handleFileUolad(e) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!headerItem.every((item, idx) => header[idx] == item)) {
                setAlert(Object.assign(Object.assign({}, alert), { divTag: t("라벨.해당양식은사용불가합니다"), type: CONST.TYPE_NONE }));
                CUTIL.jsopen_AlertPopup(CONST.POP_ALERT);
            }
            else {
                setLoadingBox(true);
                setFileName("");
                let data = [];
                let dataList = [];
                let dataSuccess = [];
                for (let i = 0; i < excelNoArr.length; i++) {
                    data = yield HTTPUTIL.PromiseHttp({
                        httpMethod: "POST",
                        appPath: "/product/item/excel",
                        appQuery: {
                            roomId: recoilTree.room.roomId,
                            excelNo: excelNoArr[i].no,
                            spgName: excelNoArr[i].설비유형,
                            panelName: excelNoArr[i].판넬명,
                            itemName: excelNoArr[i].형명,
                            serialNo: excelNoArr[i].시리얼번호,
                            manufacturer: excelNoArr[i].제조사,
                            madeyyyyMM: excelNoArr[i].제조년월,
                            memo: excelNoArr[i].메모,
                            elecInfo: excelNoArr[i].key.map((item) => ({
                                elecCode: item,
                                value: excelNoArr[i][item],
                            })),
                        },
                        userToken: userInfo.loginInfo.token,
                    });
                    if (data) {
                        dataList = dataList.concat(data);
                        setStatus(dataList);
                        if (data.msg == "success") {
                            dataSuccess.push(data);
                        }
                    }
                }
                if (data) {
                    setUploadFileName(fileName);
                    if (dataSuccess.length > 0) {
                        deviceNotic(recoilTree.room.roomId);
                    }
                    setLoadingBox(false);
                }
            }
        });
    }
    function deviceNotic(roomId) {
        return __awaiter(this, void 0, void 0, function* () {
            let data = null;
            data = yield HTTPUTIL.PromiseHttp({
                httpMethod: "POST",
                appPath: "/product/item/excel/notice",
                appQuery: {
                    roomId: roomId,
                },
                userToken: userInfo.loginInfo.token,
            });
            if (data) {
                if (data.codeNum == CONST.API_200) {
                }
                else {
                }
            }
        });
    }
    function Download(e) {
        let atag = document.createElement("a");
        atag.href = "https://repoehp.blob.core.windows.net/repoehp-rel-item/item/기기일괄등록양식_v1.0.xlsx";
        atag.click();
    }
    function FinishPops(e) {
        setSuccessList(success);
        setFailList(fail);
        CUTIL.jsopen_Popup(e);
    }
    return (_jsx(_Fragment, { children: _jsx("section", Object.assign({ className: "content wcal-296" }, { children: _jsxs("article", Object.assign({ className: "box" }, { children: [_jsx("div", Object.assign({ className: "box__header flex-column brd-bottom-0 pb-0" }, { children: _jsxs("div", Object.assign({ className: "flex-inline gap-14" }, { children: [_jsx("h2", Object.assign({ className: "box__title" }, { children: recoilTree.company.companyName + " " + recoilTree.zone.zoneName })), _jsxs("div", Object.assign({ className: "select subzone", onClick: (e) => recoilTree.subZone.subZoneId && SubZoneSelect(e) }, { children: [_jsxs("div", Object.assign({ className: "selected" }, { children: [_jsx("div", Object.assign({ className: "selected-value" }, { children: recoilTree.subZone.subZoneId && recoilTree.subZone.subZoneName })), _jsx("div", { className: recoilTree.subZone.subZoneId ? "arrow" : "" })] })), _jsxs("ul", { children: [_jsx("li", Object.assign({ className: "option", onClick: (e) => onClickSubZone("all") }, { children: "\uC804\uCCB4" })), subZoneInfo.length > 0 &&
                                                    subZoneInfo.map((info, idx) => (_jsx("li", Object.assign({ className: "option", onClick: (e) => onClickSubZone(info) }, { children: info.subZoneName }), "subZone_" + idx.toString())))] })] })), recoilTree.subZone.subZoneId && (_jsxs("div", Object.assign({ className: "select room", onClick: (e) => RoomSelect(e) }, { children: [_jsxs("div", Object.assign({ className: "selected" }, { children: [_jsx("div", Object.assign({ className: "selected-value", "data-value": recoilTree.room.roomId ? recoilTree.room.roomName : "" }, { children: recoilTree.room.roomId ? recoilTree.room.roomName : t("라벨.전체") })), _jsx("div", { className: "arrow" })] })), _jsxs("ul", { children: [_jsx("li", Object.assign({ className: "option", onClick: (e) => onClickRoom("all") }, { children: "\uC804\uCCB4" })), roomInfo.length > 0 &&
                                                    roomInfo.map((info, idx) => (_jsx("li", Object.assign({ className: "option", onClick: (e) => onClickRoom(info) }, { children: info.roomName }), "room_" + idx.toString())))] })] })))] })) })), _jsxs("div", Object.assign({ className: "box__body" }, { children: [_jsx("div", Object.assign({ className: "content__info hmin-240" }, { children: _jsx("div", Object.assign({ className: "top mt-46" }, { children: _jsxs("ul", Object.assign({ className: "upload-area" }, { children: [status.length <= 0 && fileName.length <= 0 ? (_jsxs("li", { children: [_jsx("button", Object.assign({ type: "button", className: "go-back tooltip-link", "data-tooltip": t("라벨.뒤로가기"), onClick: (e) => onClickTab("SITE") }, { children: _jsx("span", Object.assign({ className: "hide" }, { children: "\uB4A4\uB85C\uAC00\uAE30" })) })), _jsx("p", Object.assign({ className: "tit" }, { children: t("라벨.엑셀업로드") })), _jsx("button", Object.assign({ type: "button", className: "btn-basic", onClick: (e) => ExcelInput(e) }, { children: _jsx("span", { children: t("라벨.가져오기") }) }))] })) : (status.length <= 0 && (_jsxs("li", { children: [_jsx("button", Object.assign({ type: "button", className: "go-back tooltip-link", "data-tooltip": t("라벨.뒤로가기"), onClick: (e) => onClickTab("SITE") }, { children: _jsx("span", Object.assign({ className: "hide" }, { children: "\uB4A4\uB85C\uAC00\uAE30" })) })), _jsx("p", Object.assign({ className: "tit" }, { children: t("라벨.엑셀업로드") })), _jsx("ul", Object.assign({ className: "filelist" }, { children: _jsx("li", { children: _jsx("span", { children: fileName }) }) })), _jsx("button", Object.assign({ type: "button", className: "btn-basic", onClick: (e) => handleFileUolad(e) }, { children: _jsx("span", { children: t("라벨.업로드") }) })), _jsx("button", Object.assign({ type: "button", className: "btn-basic bg-gray", onClick: (e) => setFileName("") }, { children: _jsx("span", { children: t("라벨.취소") }) }))] }))), status.length > 0 && (_jsxs("li", { children: [_jsx("button", Object.assign({ type: "button", className: "go-back tooltip-link", "data-tooltip": t("라벨.뒤로가기"), onClick: (e) => onClickTab("SITE") }, { children: _jsx("span", Object.assign({ className: "hide" }, { children: "\uB4A4\uB85C\uAC00\uAE30" })) })), _jsx("p", Object.assign({ className: "tit" }, { children: t("라벨.엑셀업로드") })), _jsx("ul", Object.assign({ className: "filelist" }, { children: _jsx("li", { children: ingNum < 100 && (_jsx("span", Object.assign({ className: `uploading ${ingNum == 100 ? "end" : ""}` }, { children: uploadFileName }))) }) })), ingNum < 100 ? (_jsx("div", Object.assign({ className: "progressbar" }, { children: _jsxs("div", Object.assign({ className: "progress-value" }, { children: [_jsx("progress", { value: ingNum, max: "100" }), _jsx("p", Object.assign({ className: "value" }, { children: _jsxs("span", { children: [ingNum, "%"] }) }))] })) }))) : (_jsx("button", Object.assign({ type: "button", className: "btn-basic", onClick: (e) => ExcelInput(e) }, { children: _jsx("span", { children: t("라벨.가져오기") }) })))] })), ingNum >= 100 && (_jsxs("li", { children: [_jsx("p", Object.assign({ className: "tit" }, { children: t("라벨.추가완료") })), _jsx("ul", Object.assign({ className: "filelist" }, { children: _jsxs("li", { children: [_jsx("span", { children: uploadFileName }), _jsxs("div", Object.assign({ className: "case-info" }, { children: [_jsxs("p", Object.assign({ className: "case-ok" }, { children: [_jsx("strong", { children: t("라벨.성공") }), _jsxs("span", { children: [success.length, " ", t("라벨.개")] })] })), _jsxs("p", Object.assign({ className: "case-no" }, { children: [_jsx("strong", { children: t("라벨.실패") }), _jsxs("span", { children: [fail.length, " ", t("라벨.개")] })] })), _jsx("button", Object.assign({ type: "button", className: "btn-go js-open", "data-pop": "pop-finish-ok", onClick: (e) => FinishPops(e) }, { children: _jsx("span", Object.assign({ className: "hide" }, { children: "\uD31D\uC5C5\uCC3D \uC5F4\uAE30" })) }))] }))] }) }))] }))] })) })) })), _jsxs("div", Object.assign({ className: "content__info line" }, { children: [_jsxs("div", Object.assign({ className: "tbl__top pt-24" }, { children: [_jsxs("div", Object.assign({ className: "left" }, { children: [_jsx("p", Object.assign({ className: "font-15" }, { children: _jsx("strong", { children: "Elec Info" }) })), _jsx("p", Object.assign({ className: "txt-info" }, { children: t("운영관리.일괄등록정보") }))] })), _jsx("div", Object.assign({ className: "right" }, { children: _jsx("button", Object.assign({ type: "button", className: "btn-basic", onClick: (e) => Download(e) }, { children: _jsx("span", { children: t("라벨.엑셀양식다운로드") }) })) }))] })), elecinfoItem && (_jsx("div", Object.assign({ className: "tbl-list scrollX-basic dark" }, { children: _jsxs("table", Object.assign({ summary: "No.,\uC124\uBE44 \uC720\uD615,Elec Info 1,... \uD56D\uBAA9\uC73C\uB85C \uAD6C\uC131\uB41C \uC6B4\uC601 \uC124\uBE44 \uB9AC\uC2A4\uD2B8 \uC785\uB2C8\uB2E4." }, { children: [_jsx("caption", { children: "\uC6B4\uC601 \uC124\uBE44 \uB9AC\uC2A4\uD2B8" }), _jsxs("colgroup", { children: [_jsx("col", { style: { width: "15px" } }), _jsx("col", { style: { width: "140px" } }), _jsx("col", { style: { width: "" } })] }), _jsx("thead", { children: _jsxs("tr", { children: [_jsx("th", Object.assign({ scope: "col" }, { children: _jsx("span", { children: "No." }) })), _jsx("th", Object.assign({ scope: "col" }, { children: _jsx("span", { children: t("라벨.설비유형") }) })), thaed.map((item, idx) => (_jsx("th", Object.assign({ scope: "col" }, { children: _jsx("span", { children: item.thName }) }), "teaed_" + idx.toString())))] }) }), _jsx("tbody", { children: elecinfoItem.map((list, idx) => (_jsxs("tr", { children: [_jsx("td", Object.assign({ className: "w30" }, { children: list.rowNum })), _jsx("td", Object.assign({ className: "w170 fontMedium" }, { children: list.spgName })), list.elecInfo.map((item, i) => item.type < 2 ? (_jsxs("td", { children: [item.name, " ", item.unit ? `(${item.unit.join(",")})` : ""] }, "deveiceAll_elec_" + list.spgName + i.toString())) : (_jsx("td", { children: _jsxs("div", Object.assign({ className: "flex-row center left-right" }, { children: [_jsx("p", Object.assign({ className: "star" }, { children: _jsx("span", Object.assign({ className: "wmax-112 ellipsis" }, { children: item.name })) })), _jsxs("div", Object.assign({ className: `select elecInfoSel_${i}  w158 ml-14`, onClick: (e) => CUTIL.onClickSelect(e, CUTIL.selectOption) }, { children: [_jsxs("div", Object.assign({ className: "selected" }, { children: [_jsx("div", Object.assign({ className: "selected-value ellipsis", title: langIds < 2 ? item.unit[0] : item.unitEn[0] }, { children: langIds < 2 ? item.unit[0] : item.unitEn[0] })), _jsx("div", { className: "arrow" })] })), _jsx("ul", { children: item.unit.map((value, j) => (_jsx("li", Object.assign({ className: "option ellipsis", title: value }, { children: value }), "type2_unit" + j.toString()))) })] }))] })) }, "deveiceAll_select_" + list.spgName + i.toString())))] }, "deveiceAll_" + idx.toString()))) })] })) })))] })), _jsx(EhpPagination, { componentName: "BATCH", pageInfo: pageInfo, handleCurPage: handleCurPage })] }))] })) })) }));
}
export default EquipmentMultiRegist;
function FinishPop(props) {
    const t = useTrans();
    // props
    const { successList, failList, thaed, onClickTab, repop } = props;
    //
    const [togles, setTogles] = useState(false);
    useEffect(() => {
        setTogles(false);
    }, [successList, failList, repop]);
    let successLists = successList.map((list) => {
        const elecInfo = thaed.map((info) => {
            const foundInfo = list.elecInfo.find((d) => d.code === info.code);
            if (foundInfo) {
                return foundInfo;
            }
            return info;
        });
        return Object.assign(Object.assign({}, list), { elecInfo });
    });
    function DevicMove(id) {
        Close(id);
        onClickTab("DEVICE");
    }
    function Close(id) {
        CUTIL.jsclose_Popup(id);
        setTogles(false);
    }
    return (_jsxs(_Fragment, { children: [_jsxs("div", Object.assign({ className: "popup__body" }, { children: [_jsxs("div", Object.assign({ className: "tbl__top" }, { children: [_jsxs("ul", Object.assign({ className: "tab__button" }, { children: [_jsx("li", Object.assign({ className: togles ? "" : "on", onClick: (e) => setTogles(false) }, { children: _jsx("a", Object.assign({ href: "#", onClick: (e) => e.preventDefault(), className: "green" }, { children: t("라벨.성공") })) })), _jsx("li", Object.assign({ className: togles ? "on" : "", onClick: (e) => setTogles(true) }, { children: _jsx("a", Object.assign({ href: "#", onClick: (e) => e.preventDefault(), className: "red" }, { children: t("라벨.실패") })) }))] })), _jsx("button", Object.assign({ type: "button", className: "btn-basic", onClick: (e) => DevicMove("pop-finish-ok") }, { children: _jsx("span", { children: "\uC6B4\uC601\uC124\uBE44 \uBAA9\uB85D\uC5D0\uC11C \uD655\uC778" }) }))] })), !togles ? (_jsx("div", Object.assign({ className: "tbl-list scrollX-basic dark scrollH h662 pr-0 mr-0" }, { children: _jsxs("table", Object.assign({ summary: "No.,\uC124\uBE44 \uC720\uD615,\uD615\uBA85,\uD310\uB12C\uBA85,\uC2DC\uB9AC\uC5BC\uBC88\uD638,\uC81C\uC870\uC0AC,\uC81C\uC870\uB144\uC6D4,\uBA54\uBAA8,Elec Info 1,... \uD56D\uBAA9\uC73C\uB85C \uAD6C\uC131\uB41C \uC5C5\uB85C\uB4DC\uC131\uACF5 \uB9AC\uC2A4\uD2B8 \uC785\uB2C8\uB2E4." }, { children: [_jsx("caption", { children: "\uC5C5\uB85C\uB4DC \uC131\uACF5 \uB9AC\uC2A4\uD2B8" }), _jsx("colgroup", { children: _jsx("col", { style: { width: "" } }) }), _jsx("thead", { children: _jsxs("tr", { children: [_jsx("th", Object.assign({ scope: "col" }, { children: _jsx("span", { children: "No." }) })), _jsx("th", Object.assign({ scope: "col" }, { children: _jsx("span", { children: t("라벨.설비유형") }) })), _jsx("th", Object.assign({ scope: "col" }, { children: _jsx("span", { children: t("라벨.형명") }) })), _jsx("th", Object.assign({ scope: "col" }, { children: _jsx("span", { children: t("라벨.판넬명") }) })), _jsx("th", Object.assign({ scope: "col" }, { children: _jsx("span", { children: t("라벨.시리얼번호") }) })), _jsx("th", Object.assign({ scope: "col" }, { children: _jsx("span", { children: t("라벨.제조사") }) })), _jsx("th", Object.assign({ scope: "col" }, { children: _jsx("span", { children: t("라벨.제조년월") }) })), _jsx("th", Object.assign({ scope: "col", className: "txt-center" }, { children: _jsx("span", { children: t("라벨.메모") }) })), thaed.map((_, idx) => (_jsx("th", Object.assign({ scope: "col" }, { children: _jsxs("span", { children: ["Elec Info ", idx + 1] }) }), "teaed_m_" + idx.toString())))] }) }), _jsx("tbody", { children: successLists.length > 0 &&
                                        successLists.map((list, idx) => (_jsxs("tr", { children: [_jsx("td", { children: idx + 1 }), _jsx("td", { children: list.spgName ? list.spgName : "-" }), _jsx("td", { children: _jsx("p", Object.assign({ className: "ellipsis" }, { children: list.itemName ? list.itemName : "-" })) }), _jsx("td", { children: _jsx("p", Object.assign({ className: "ellipsis wmax-80" }, { children: list.panelName ? list.panelName : "-" })) }), _jsx("td", Object.assign({ className: "wmin-152" }, { children: list.serialNo ? list.serialNo : "-" })), _jsx("td", { children: list.manufacturer ? list.manufacturer : "-" }), _jsx("td", { children: list.madeyyyyMM ? dayjs(list.madeyyyyMM).format("YYYY-MM") : "-" }), _jsx("td", { children: _jsx("button", Object.assign({ type: "button", className: `btn btn-comment m-0 js-open ${list.memo ? "on" : ""}`, "data-pop": "pop-memo" }, { children: _jsx("span", Object.assign({ className: "hide" }, { children: t("라벨.메모") })) })) }), list.elecInfo
                                                    .sort((a, b) => (a.code > b.code ? 1 : -1))
                                                    .map((item, i) => item.id !== null ? (_jsxs("td", { children: [item.name, " ", item.value ? item.value : "-", " ", item.unit ? `(${item.unit})` : ""] }, "deveiceAll_elec_m_" + i.toString())) : (_jsx("td", { children: "-" }, "deveiceAll_elec_none_" + i.toString())))] }, "success_list_" + idx.toString()))) })] })) }))) : (
                    // <!--실패테이블>-->
                    _jsx("div", Object.assign({ className: "tbl-list scrollH dark h662 pr-0 mr-0" }, { children: _jsxs("table", Object.assign({ summary: "No.,Excel No.,\uD615\uBA85,\uC2DC\uB9AC\uC5BC\uBC88\uD638,\uC2E4\uD328\uC0AC\uC720 \uD56D\uBAA9\uC73C\uB85C \uAD6C\uC131\uB41C \uC5C5\uB85C\uB4DC \uC2E4\uD328 \uB9AC\uC2A4\uD2B8 \uC785\uB2C8\uB2E4." }, { children: [_jsx("caption", { children: "\uC5C5\uB85C\uB4DC \uC2E4\uD328 \uB9AC\uC2A4\uD2B8" }), _jsxs("colgroup", { children: [_jsx("col", { style: { width: "5%" } }), _jsx("col", { style: { width: "8%" } }), _jsx("col", { style: { width: "14%" } }), _jsx("col", { style: { width: "15%" } }), _jsx("col", { style: { width: "" } })] }), _jsx("thead", { children: _jsxs("tr", { children: [_jsx("th", Object.assign({ scope: "col" }, { children: _jsx("span", { children: "No." }) })), _jsx("th", Object.assign({ scope: "col" }, { children: _jsx("span", { children: "Excel No." }) })), _jsx("th", Object.assign({ scope: "col" }, { children: _jsx("span", { children: t("라벨.형명") }) })), _jsx("th", Object.assign({ scope: "col" }, { children: _jsx("span", { children: t("라벨.시리얼번호") }) })), _jsx("th", Object.assign({ scope: "col" }, { children: _jsx("span", { children: "\uC2E4\uD328 \uC0AC\uC720" }) }))] }) }), _jsx("tbody", { children: failList.length > 0 &&
                                        failList
                                            .sort((a, b) => (a.excelNo > b.excelNo ? 1 : -1))
                                            .map((list, idx) => !list.errorCode ? (_jsxs("tr", { children: [_jsx("td", { children: idx + 1 }), _jsx("td", { children: list.excelNo }), _jsx("td", { children: _jsx("p", Object.assign({ className: "ellipsis" }, { children: list.itemName })) }), _jsx("td", Object.assign({ className: "wmin-152" }, { children: list.serialNo })), list.errorList
                                                    .filter((_, i) => i == 0)
                                                    .map((err, j) => (_jsxs("td", { children: [err.field, " ", err.msg] }, "err_" + j.toString())))] }, "fail_list_" + idx.toString())) : list.errorList !== null ? (_jsxs("tr", { children: [_jsx("td", { children: idx + 1 }), list.errorList
                                                    .filter((_, i) => i == 0)
                                                    .map((err, j) => (_jsxs("td", Object.assign({ colSpan: 3 }, { children: [err.field, " ", err.msg] }), "error_" + j.toString())))] }, "err_list_" + idx.toString())) : (_jsxs("tr", { children: [_jsx("td", { children: idx + 1 }), _jsx("td", Object.assign({ colSpan: 3 }, { children: list.solution }))] }, "err_list_" + idx.toString()))) })] })) }))), _jsx("div", Object.assign({ className: "tbl__bottom" }, { children: _jsxs("p", Object.assign({ className: "result__num" }, { children: ["Total : ", _jsx("span", { children: !togles ? successLists.length : failList.length })] })) }))] })), _jsx("div", Object.assign({ className: "popup__footer" }, { children: _jsx("button", Object.assign({ type: "button", className: "js-close", onClick: (e) => Close("pop-finish-ok") }, { children: _jsx("span", { children: t("라벨.확인") }) })) }))] }));
}
